<template>
	<router-view></router-view>
</template>

<script>
	export default {};
</script>

<!-- <template>
	<v-row class="fill-height">
		<v-col cols="6">
			<v-sheet height="64">
				<v-toolbar color="info" flat>
					<v-btn outlined class="mr-4" color="white darken-2" @click="setToday">
						Today
					</v-btn>
					
					<v-btn fab text small color="grey darken-2" @click="prev">
						<v-icon color="white">
							mdi-chevron-left
						</v-icon>
					</v-btn>
					<v-toolbar-title v-if="$refs.calendar">
						{{ $refs.calendar.title }}
					</v-toolbar-title>
					<v-btn fab text small color="grey darken-2" @click="next">
						<v-icon color="white">
							mdi-chevron-right
						</v-icon>
					</v-btn>
					<v-toolbar-title>
						排课月历表
					</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-menu bottom right>
						<template v-slot:activator="{ on, attrs }">
							<v-btn outlined color="white darken-2" v-bind="attrs" v-on="on">
								<span>{{ typeToLabel[type] }}</span>
								<v-icon right>
									mdi-menu-down
								</v-icon>
							</v-btn>
						</template>
						<v-list>
							<v-list-item @click="type = 'day'">
								<v-list-item-title>按日</v-list-item-title>
							</v-list-item>
							<v-list-item @click="type = 'week'">
								<v-list-item-title>按周</v-list-item-title>
							</v-list-item>
							<v-list-item @click="type = 'month'">
								<v-list-item-title>按月</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</v-toolbar>
			</v-sheet>
			<v-sheet height="600">
				<v-calendar ref="calendar" v-model="focus" color="light" :events="events" :event-color="getEventColor"
					:type="type" @click:event="showEvent" @click:more="viewDay" @click:date="viewDay"
					@change="updateRange"></v-calendar>
				<v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
					<v-card color="grey lighten-4" width="350px" flat>
						<v-toolbar :color="selectedEvent.color" dark dense>
							
							<v-toolbar-title v-html="'课程详情'"></v-toolbar-title>
							<v-spacer></v-spacer>
							<v-btn icon @click="selectedOpen = false">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-toolbar>
						<v-card-text>
							<span class="black--text" v-html="selectedEvent.details"></span>
						</v-card-text>
					</v-card>
				</v-menu>
			</v-sheet>
		</v-col>
	</v-row>
</template>

<script>
	export default {
		name: "homePage",
		data() {
			return {
				focus: '',
				type: 'month',
				typeToLabel: {
					month: '按月',
					week: '按周',
					day: '按日',
				},
				selectedEvent: {},
				selectedElement: null,
				selectedOpen: false,
				events: [],
			}
		},
		mounted() {
			this.$refs.calendar.checkChange()
			
		},
		methods: {
			viewDay({date}) {
				
				this.focus = date;
				this.type = 'day';
				this.$refs.calendar.scrollToTime('08:00');
			},
			getEventColor(event) {
				return event.color
			},
			setToday() {
				this.focus = ''
			},
			prev() {
				this.$refs.calendar.prev()
			},
			next() {
				this.$refs.calendar.next()
			},
			showEvent({nativeEvent,event}) {
				const open = () => {
					this.selectedEvent = event
					this.selectedElement = nativeEvent.target
					requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
				}

				if (this.selectedOpen) {
					this.selectedOpen = false
					requestAnimationFrame(() => requestAnimationFrame(() => open()))
				} else {
					open()
				}

				nativeEvent.stopPropagation()
			},
			updateRange({start,end}) {
				
				const that = this;
	
				const url = `/edu/class/record/list/start/${start.date}/end/${end.date}`
				this.axios.get(url).then(response => {
				

					if (response.data["code"] === 200) {
						
						const dataList = response.data["data"];
						const events = []
						
						dataList.forEach((item,index)=>{
							
							let detailHtml = "时间:"+item.classDate + " "+ item.timeFrom + "-"+item.timeTo+"<br/>";
							detailHtml = detailHtml + "课程:"+item.courseName + "<br/>";
							detailHtml = detailHtml + "班级:"+item.className + "<br/>";
							detailHtml = detailHtml + "教室:"+item.roomName + "<br/>";
							detailHtml = detailHtml + "老师:"+item.teacherName + "<br/>";
							
							events.push({
								name: item.courseName + "/"+ item.teacherName,
								start: new Date(`${item.classDate}T${item.timeFrom}`),
								end:  new Date(`${item.classDate}T${item.timeTo}`),
								color: 'green',
								timed: true,
								details:detailHtml,
								
							})
							
						})
						
						that.events = events
						
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
		},

	}
</script>
 -->